module.exports = __webpack_public_path__ + "assets/img/kv-9e179b1b.jpg";